import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'check-monitoring'
const Actions = crudActions(endpoint)

const create = (ctx, data) => new Promise((resolve, reject) => {
  axios.post(`/${endpoint}`, data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const patch = (ctx, checkMonitoring) => new Promise((resolve, reject) => {
  axios[checkMonitoring.id ? 'patch' : 'post'](`/${endpoint}/${checkMonitoring.id}/`, checkMonitoring)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const listView = (ctx, queryParams) => {
  const { id } = queryParams
  // eslint-disable-next-line no-param-reassign
  delete queryParams.id
  return axios.get(`/${endpoint}/${id}/view`, { params: queryParams })
}
const checkMonitoringListInnovation = (ctx, queryParams) => axios.get(`${endpoint}/check-monitoring-list-innovation`, { params: queryParams })
export default {
  ...Actions,
  create,
  listView,
  patch,
  checkMonitoringListInnovation,
}
